import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { throwError, timer } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

export const retryInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.method !== 'GET') {
    return next(req);
  }
  return next(req).pipe(
    retry({
      count: 3,
      delay: (error: HttpErrorResponse, retryAttempt: number) => {
        if (error.status === 0 || error.status >= 500) {
          const delayTime = retryAttempt * 3000;
          return timer(delayTime);
        }
        return throwError(() => error);
      },
    }),
    catchError((error: HttpErrorResponse) => {
      return throwError(() => error);
    }),
  );
};
